import { render, staticRenderFns } from "./rewardRecord.vue?vue&type=template&id=2f006438&"
import script from "./rewardRecord.vue?vue&type=script&lang=js&"
export * from "./rewardRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports